import {ICampaignOverview} from '../../../../model/briefing/overview/ICampaignOverview';
import {requests} from '../../../../utils';
import {INFLUENCER_BRIEFING} from '../../../../utils/endpoints';

export const InfluencerBriefingService = {
    getBriefingSummary: (id: string): Promise<ICampaignOverview> => requests.get(`${INFLUENCER_BRIEFING}/summary/${id}`),
};